<script>
import { fetchLastUpdated } from '@/api/dashboard'
import { useAuthStore } from '@/stores/authStore'
import { useDashboardStore } from '@/stores/dashboardStore'
import { useThemeStore } from '@/stores/themeStore'
import SettingsModal from '@/components/common/SettingsModal.vue'
import MyPageModal from '@/components/common/MyPageModal.vue'
import headerLogo from '@/asesets/images/header/wiplat-logo.svg'
import { setLocale } from '@/i18n'

// 지원 언어 — 각 언어는 자국어 표기로 노출 (현재 locale 과 무관하게 고정)
const LANG_OPTIONS = [
  { value: 'ko', label: '한국어' },
  { value: 'en', label: 'English' },
  { value: 'vn', label: 'Tiếng Việt' },
]

const COUNTRY = 'KR'

export default {
  name: 'HeaderBar',
  components: { SettingsModal, MyPageModal },
  setup() {
    return {
      authStore: useAuthStore(),
      dashStore: useDashboardStore(),
      themeStore: useThemeStore(),
      headerLogo,
      langOptions: LANG_OPTIONS,
    }
  },
  watch: {
    customer_id() {
      sessionStorage.select_customer_id = this.customer_id;
      sessionStorage.select_customer_no = this.customer_no_list[this.customer_id];
      //console.log(sessionStorage.select_customer_no );
      this.$router.go(this.$router.currentRoute);
    },
  },
  data() {
    return {
      lastUpdated: null,
      updateInterval: null,
      userId: sessionStorage.m_id || '',
      customer_id: sessionStorage.select_customer_id === undefined ? "1" : sessionStorage.select_customer_id,
      customer_name: [],
      customer_no_list: {},
      ischange: false,
      settingsOpen: false,
      myPageOpen: false,
      adminMenuOpen: false,
      // Teleport 된 드롭다운 위치 (button bounding rect 기준)
      adminMenuStyle: { top: '0px', left: '0px' },
    }
  },
  computed: {
    // 헤더 언어 선택 — get 은 현재 i18n locale, set 은 setLocale 헬퍼(localStorage 저장 + <html lang> 동기화)
    currentLocale: {
      get() { return this.$i18n.locale },
      set(val) { setLocale(val) },
    },
    selectedValue: {
      get() { return this.dashStore.selectedCustomer || '__all__' },
      async set(val) {
        if (val === '__all__') {
          await this.dashStore.loadAllCustomers(COUNTRY)
        } else {
          await this.dashStore.selectCustomer(val)
        }
      },
    },
    // 선택된 고객사 이름 — customer_name 배열에서 현재 customer_id 매칭
    selectedCustomerName() {
      const found = (this.customer_name || []).find(c => String(c.value) === String(this.customer_id))
      return found?.text || ''
    },
    // 로그인 사용자의 home customer_id (login 시 sessionStorage.customer_id 에 저장)
    //   == 1 인 경우만 admin 권한 — 고객사 변경 select + 관리자 메뉴 노출
    isAdminCustomer() {
      return Number(sessionStorage.customer_id) === 1
    },
    // 관리자 메뉴 노출 조건 — home customer_id === 1 일 때만
    isWiplatCustomer() {
      return this.isAdminCustomer
    },
    adminMenuItems() {
      return [
        { key: 'customers', label: this.$t('header.admin_customers'), to: '/admin/customers' },
        { key: 'workers',   label: this.$t('header.admin_workers'),   to: '/admin/workers' },
        { key: 'devices',   label: this.$t('header.admin_devices'),   to: '/admin/devices' },
        { key: 'alarms',    label: this.$t('header.admin_alarms'),    to: '/admin/alarms' },
        { key: 'mnp',           label: this.$t('header.admin_mnp'),           to: '/admin/mnp' },
        { key: 'press_datacheck', label: this.$t('header.admin_press_datacheck'), to: '/admin/press-datacheck' },
      ]
    },
  },
  mounted() {
    // 관리자 드롭다운 — 외부 클릭으로 닫기
    document.addEventListener('mousedown', this.onDocClick)
    //this.loadLastUpdated()
    //this.updateInterval = window.setInterval(this.loadLastUpdated, 5 * 60 * 1000)
    this.customer_name = [];
    this.customer_no_list = {};
    this.$http.get(this.URL + "api/get_all_customer_list?sort=name").then((rows) => {
      if (!rows || rows.data.list <= 0) return;
      for (let i = 0; i < rows.data.list.length; i++) {
        this.customer_name.push({
          isNew : rows.data.list[i].isNew  , 
          value: rows.data.list[i].id,
          text: rows.data.list[i].name + "",
        });
        this.customer_no_list[rows.data.list[i].id] =
          rows.data.list[i].customer_no;
      }
    });    
  },
  beforeUnmount() {
    //clearInterval(this.updateInterval)
    document.removeEventListener('mousedown', this.onDocClick)
  },
  methods: {
    formatUpdatedTime(iso) {
      const d = new Date(iso)
      const pad = (n) => n.toString().padStart(2, '0')
      // i18n datetime_format 의 {y}/{m}/{d}/{h}/{i} 플레이스홀더 치환
      return this.$t('header.datetime_format', {
        y: d.getFullYear(),
        m: pad(d.getMonth() + 1),
        d: pad(d.getDate()),
        h: pad(d.getHours()),
        i: pad(d.getMinutes()),
      })
    },
    async loadLastUpdated() {
      try {
        this.lastUpdated = await fetchLastUpdated()
      } catch {
        // silent
      }
    },
    onDocClick(e) {
      if (!this.adminMenuOpen) return
      const root  = this.$refs.adminMenu
      const popup = this.$refs.adminMenuPopup
      // 버튼 자체 또는 Teleport 된 드롭다운 영역 클릭은 무시
      if (root && root.contains(e.target)) return
      if (popup && popup.contains(e.target)) return
      this.adminMenuOpen = false
    },
    toggleAdminMenu() {
      if (!this.adminMenuOpen) {
        // 버튼 위치 기준으로 드롭다운 좌표 계산 (Teleport to body)
        const btn = this.$refs.adminBtn
        if (btn) {
          const r = btn.getBoundingClientRect()
          this.adminMenuStyle = {
            top:  `${Math.round(r.bottom + 4)}px`,
            left: `${Math.round(r.left)}px`,
          }
        }
      }
      this.adminMenuOpen = !this.adminMenuOpen
    },
    onAdminMenuClick(item) {
      this.adminMenuOpen = false
      if (!item?.to) {
        // 라우터 미연결 항목 — 추후 화면 추가 시 to 채워 넣기
        alert(this.$t('header.admin_coming_soon'))
        return
      }
      this.$router.push(item.to)
    },
    // 유사 사이트 — 별도 페이지로 이동 (server_list API)
    onSimilarSites() {
      if (this.$route.name !== 'similar-sites') this.$router.push('/similar-sites')
    },
    // 로고 클릭 — 대시보드(/)로 이동 (현재 경로가 / 면 동작 안 함)
    onLogoClick() {
      if (this.$route.path !== '/') this.$router.push('/')
    },
    onManual() {
      // public/manual/dashboard-manual{,-en}.html — Vue CLI BASE_URL(publicPath) 기준 URL 조립
      //   현재 i18n locale 에 따라 한글/영문판 분기 (vn 등은 한글판 기본)
      const base = process.env.BASE_URL || '/'
      const locale = this.$i18n?.locale || 'ko'
      const file = locale === 'en' ? 'dashboard-manual-en.html' : 'dashboard-manual.html'
      const url  = `${base.replace(/\/$/, '')}/manual/${file}`
      window.open(url, '_blank', 'noopener,noreferrer')
    },
  },
}
</script>

<template>
  <header class="header header-bar">
    <div class="header-left">
      <img
        :src="headerLogo"
        :alt="$t('header.logo_alt')"
        class="logo-img"
        :title="$t('header.logo_alt')"
        @click="onLogoClick"
      />
      <span class="brand-name">NELOW</span>
      <span class="brand-title">{{ $t('header.brand_title') }}</span>
    </div>
    <div class="header-right">
      <span v-if="lastUpdated" class="last-updated">
        {{ $t('header.last_updated') }} <span class="updated-val">{{ formatUpdatedTime(lastUpdated) }}</span>
      </span>
      <!-- 고객사 선택 -->
      <div class="customer-wrap">
        <span class="customer-label">{{ $t('header.customer') }}</span>
        <select v-model="customer_id" class="customer-select" :disabled="ischange || !isAdminCustomer">
          <!--option value="__all__">전체 ({{ dashStore.detail.length }}곳)</option-->
          <option v-for="(option, index) in customer_name" v-bind:value="option.value" :key="index" >
            {{  option.text }}
          </option>
        </select>
      </div>

      <!-- 관리자 메뉴 — 고객사가 Wiplat 인 경우에만 노출 -->
      <div v-if="isWiplatCustomer" ref="adminMenu" class="admin-menu">
        <button
          ref="adminBtn"
          class="btn-admin"
          :class="{ on: adminMenuOpen }"
          :title="$t('header.admin')"
          @click="toggleAdminMenu"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
          <span class="admin-label">{{ $t('header.admin') }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>
        <!-- body 로 Teleport — 헤더의 stacking context(z:1000)를 벗어나 모든 모달/배너 위로 -->
        <Teleport to="body">
          <ul
            v-if="adminMenuOpen"
            ref="adminMenuPopup"
            class="admin-dropdown"
            :style="adminMenuStyle"
          >
            <li v-for="item in adminMenuItems" :key="item.key">
              <button class="admin-item" @click="onAdminMenuClick(item)">{{ item.label }}</button>
            </li>
          </ul>
        </Teleport>
      </div>

      <!-- 언어 선택 — 브라우저 언어 자동감지 위에 수동 override (localStorage 'locale' 저장) -->
      <div class="lang-wrap">
        <svg class="lang-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="2" y1="12" x2="22" y2="12"/>
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
        </svg>
        <select v-model="currentLocale" class="lang-select" :title="$t('header.language')" :aria-label="$t('header.language')">
          <option v-for="opt in langOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
        </select>
      </div>

      <div class="user-area">
        <button class="btn-mypage" @click="myPageOpen = true" :title="$t('mypage_info.btn_open')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </button>
        <button class="btn-settings" @click="settingsOpen = true" :title="$t('header.settings')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09a1.65 1.65 0 00-1-1.51 1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09a1.65 1.65 0 001.51-1 1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
          </svg>
        </button>
        <button class="btn-logout" @click="authStore.logout()" :title="$t('header.logout')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </button>
        <button class="btn-icon" @click="onManual" :title="$t('header.manual')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
          </svg>
        </button>
        <button class="btn-icon" @click="onSimilarSites" :title="$t('header.similar_sites')">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
          </svg>
        </button>
        <button class="btn-icon" @click="themeStore.toggle()" :title="$t('header.theme_toggle')">
          <svg v-if="themeStore.isDark" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="4"/>
            <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
          </svg>
        </button>
      </div>
    </div>

    <SettingsModal :open="settingsOpen" @close="settingsOpen = false" @apply="$emit('settings-apply', $event)" />
    <MyPageModal :open="myPageOpen" @close="myPageOpen = false" />
  </header>
</template>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 1.25rem;
  background:
    radial-gradient(1200px 220px at 35% -180px, rgba(var(--accent-rgb), .22), transparent 65%),
    linear-gradient(180deg, rgba(var(--accent-rgb), .06), transparent 55%),
    var(--bg-surface);
  border-bottom: 1px solid var(--border-subtle);
  box-shadow: inset 0 -1px 0 rgba(var(--accent-rgb), .14);
  flex-shrink: 0;
  /* position+z-index 함께 지정해야 stacking context 가 실제로 생성됨 — 드롭다운이 본문 위로 */
  position: relative;
  z-index: 1000;
  overflow: hidden;
}

.header::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent 0%, var(--accent) 22%, var(--accent) 78%, transparent 100%);
  opacity: .9;
  pointer-events: none;
}

.header::after {
  content: '';
  position: absolute;
  left: 12%;
  top: -36px;
  width: 360px;
  height: 72px;
  background: radial-gradient(circle, rgba(var(--accent-rgb), .28), transparent 70%);
  filter: blur(8px);
  pointer-events: none;
}

.header-left { display: flex; align-items: center; gap: 0.625rem; }
.header-left .logo-img {
  cursor: pointer;
  transition: opacity .15s;
  height: 1.625rem;
  width: auto;
  object-fit: contain;
}
.header-left .logo-img:hover { opacity: .85; }
.header-left .brand-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: .02em;
  padding-left: 0.625rem;
  border-left: 1px solid var(--border-subtle);
  white-space: nowrap;
}

.logo-mark {
  width: 2.8rem;
  height: auto;
  flex-shrink: 0;
}

.brand-name {
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: .08em;
  color: #ffffff;
  white-space: nowrap;
}

.header-right { display: flex; align-items: center; gap: 1rem; }

.last-updated { font-size: 0.875rem; color: var(--text-disabled); font-family: monospace; }
.updated-val { color: var(--text-secondary); }

.customer-wrap {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0 0.75rem;
  border-left: 1px solid rgba(var(--accent-rgb), .25);
  border-right: 1px solid rgba(var(--accent-rgb), .25);
}

.customer-label {
  font-size: 0.75rem;
  color: var(--text-disabled);
  white-space: nowrap;
  font-weight: 500;
}

.customer-select {
  padding: 3px 8px;
  font-size: 0.8125rem;
  background-color: var(--bg-surface-2);
  color: var(--text-primary);
  border: 1px solid var(--border-subtle);
  border-radius: 0.375rem;
  outline: none;
  cursor: pointer;
  transition: border-color .2s, box-shadow .2s;
}
.customer-select:focus {
  border-color: var(--accent-soft-strong);
  box-shadow: 0 0 0 2px rgba(var(--accent-rgb), .14);
}
.customer-select:disabled { opacity: .6; cursor: not-allowed; }

/* 언어 선택 — 고객사 select 와 동일 톤, 좌측 글로브 아이콘 */
.lang-wrap { display: flex; align-items: center; gap: 0.375rem; }
.lang-icon { color: var(--text-disabled); flex-shrink: 0; }
.lang-select {
  padding: 3px 8px;
  font-size: 0.8125rem;
  background-color: var(--bg-surface-2);
  color: var(--text-primary);
  border: 1px solid var(--border-subtle);
  border-radius: 0.375rem;
  outline: none;
  cursor: pointer;
  transition: border-color .2s, box-shadow .2s;
}
.lang-select:focus {
  border-color: var(--accent-soft-strong);
  box-shadow: 0 0 0 2px rgba(var(--accent-rgb), .14);
}

.customer-loading {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--status-warn);
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

/* 관리자 메뉴 — 고객사가 Wiplat 일 때만 표시 */
.admin-menu { position: relative; }
.btn-admin {
  display: inline-flex; align-items: center; gap: 0.375rem;
  padding: 4px 10px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: .04em;
  background: rgba(var(--accent-rgb), .1);
  color: var(--accent);
  border: 1px solid rgba(var(--accent-rgb), .45);
  border-radius: 0.25rem;
  cursor: pointer;
  transition: color .15s, background .15s, border-color .15s, box-shadow .15s;
}
.btn-admin:hover, .btn-admin.on {
  background: rgba(var(--accent-rgb), .18);
  color: var(--accent);
  border-color: var(--accent);
  box-shadow: 0 0 0 1px rgba(var(--accent-rgb), .25) inset;
}
.admin-label { white-space: nowrap; }
/* body 로 Teleport — top/left 인라인 스타일로 버튼 위치 기준 배치 */
.admin-dropdown {
  position: fixed;
  margin: 0;
  list-style: none;
  padding: 4px;
  min-width: 9rem;
  background: var(--bg-base);
  border: 1px solid var(--border-subtle);
  border-radius: 0.375rem;
  box-shadow: 0 8px 24px var(--shadow-elev-strong);
  /* 모든 모달/배너/툴바 위로 — 최상단 노출 */
  z-index: 2147483647;
}
.admin-item {
  width: 100%;
  text-align: left;
  padding: 6px 10px;
  background: transparent;
  border: none;
  border-radius: 0.25rem;
  color: var(--text-secondary);
  font-size: 0.8125rem;
  cursor: pointer;
  transition: background .12s, color .12s;
}
.admin-item:hover { background: var(--accent-soft); color: var(--accent); }

.user-area {
  display: flex; align-items: center; gap: 0.5rem;
  margin-left: 0.5rem; padding-left: 0.75rem;
  border-left: 1px solid var(--border-subtle);
}

.username { font-size: 0.875rem; color: var(--text-disabled); }

.btn-logout {
  display: flex; align-items: center; justify-content: center;
  width: 1.75rem; height: 1.75rem;
  color: var(--text-disabled);
  background: none;
  border: 1px solid var(--border-subtle);
  border-radius: 0.25rem;
  cursor: pointer;
  transition: color .2s, border-color .2s, background .2s;
}
.btn-logout:hover { color: var(--status-err); border-color: rgba(var(--status-err-rgb),.4); background: rgba(var(--status-err-rgb),.06); }

.btn-icon,
.btn-settings,
.btn-mypage {
  display: flex; align-items: center; justify-content: center;
  width: 1.75rem; height: 1.75rem;
  color: var(--text-disabled);
  background: none;
  border: 1px solid var(--border-subtle);
  border-radius: 0.25rem;
  cursor: pointer;
  transition: color .2s, border-color .2s, background .2s;
}
.btn-icon:hover,
.btn-settings:hover,
.btn-mypage:hover {
  color: var(--accent);
  border-color: var(--accent-soft-strong);
  background: var(--accent-soft);
  box-shadow: 0 0 0 1px rgba(var(--accent-rgb), .22) inset;
}
</style>

<style>
/* 라이트 테마 — 헤더바를 진한 네이비 솔리드로. 글자/아이콘 흰색, 상단 sky 포인트 라인 */
:root[data-theme="light"] .header-bar {
  background: linear-gradient(180deg, var(--bar-bg-2), var(--bar-bg));
  border-bottom-color: rgba(0,0,0,.25);
  box-shadow:
    inset 0 -1px 0 rgba(255,255,255,.06),
    0 8px 20px rgba(0,0,0,.30);
}

:root[data-theme="light"] .header-bar::before {
  height: 3px;
  opacity: 1;
  background: linear-gradient(90deg, transparent 0%, var(--bar-point) 18%, var(--bar-point) 82%, transparent 100%);
  box-shadow: 0 0 14px rgba(34,211,238,.5);
}

:root[data-theme="light"] .header-bar::after {
  left: 6%;
  top: -54px;
  width: 760px;
  height: 160px;
  background: radial-gradient(circle, rgba(34,211,238,.18), transparent 74%);
}

:root[data-theme="light"] .header-bar .brand-title,
:root[data-theme="light"] .header-bar .brand-name {
  color: var(--bar-fg);
}

:root[data-theme="light"] .header-bar .brand-title {
  border-left-color: rgba(255,255,255,.25);
}

:root[data-theme="light"] .header-bar .customer-wrap,
:root[data-theme="light"] .header-bar .user-area {
  border-color: var(--bar-border);
}

:root[data-theme="light"] .header-bar .last-updated,
:root[data-theme="light"] .header-bar .customer-label,
:root[data-theme="light"] .header-bar .updated-val,
:root[data-theme="light"] .header-bar .lang-icon {
  color: var(--bar-fg-muted);
}

:root[data-theme="light"] .header-bar .btn-icon,
:root[data-theme="light"] .header-bar .btn-settings,
:root[data-theme="light"] .header-bar .btn-mypage {
  color: var(--bar-fg);
  border-color: var(--bar-border);
  background: var(--bar-hover-bg);
}
:root[data-theme="light"] .header-bar .btn-icon:hover,
:root[data-theme="light"] .header-bar .btn-settings:hover,
:root[data-theme="light"] .header-bar .btn-mypage:hover {
  color: #fff;
  border-color: rgba(255,255,255,.4);
  background: rgba(255,255,255,.16);
  box-shadow: none;
}

:root[data-theme="light"] .header-bar .btn-logout {
  color: var(--bar-fg-muted);
  border-color: var(--bar-border);
}
:root[data-theme="light"] .header-bar .btn-logout:hover {
  color: var(--status-err);
  border-color: rgba(var(--status-err-rgb),.6);
  background: rgba(255,255,255,.12);
}

:root[data-theme="light"] .header-bar .btn-admin {
  background: rgba(255,255,255,.12);
  color: #fff;
  border-color: var(--bar-border);
}
:root[data-theme="light"] .header-bar .btn-admin:hover,
:root[data-theme="light"] .header-bar .btn-admin.on {
  background: rgba(255,255,255,.2);
  border-color: rgba(255,255,255,.45);
  box-shadow: none;
}
</style>
